/* NASQA motion — pure code, no generated media.
   Cinematic gallery, pointer zoom, scroll reveals, cart feedback. */
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('js-motion');

  /* ---------------- scroll reveal ---------------- */
  /*
   * Two reveals, not ten.
   *
   * The old ladder stamped data-reveal on ten separate elements with delays up
   * to 350ms, so the buy column assembled itself piece by piece in front of
   * the reader. On desktop the column is sticky and already in view at load,
   * which meant the page's most important content spent its first half second
   * arriving. Anyone scrolling at normal speed met half-faded copy.
   *
   * The two columns now arrive as two objects, once.
   *
   * .offer and .dispatch are deliberately excluded: they start [hidden], so an
   * observer would never see them intersect and they would stay at opacity 0
   * once JS unhid them.
   */
  const revealTargets = [
    ['.pdp__media', 0],
    ['.pdp__buy', 80],
  ];

  revealTargets.forEach(([selector, delay]) => {
    document.querySelectorAll(selector).forEach((el) => {
      el.setAttribute('data-reveal', '');
      el.style.setProperty('--reveal-delay', `${delay}ms`);
    });
  });

  const revealables = [...document.querySelectorAll('[data-reveal]')];

  if (reduced || !('IntersectionObserver' in window)) {
    revealables.forEach((el) => el.classList.add('is-revealed'));
  } else {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    revealables.forEach((el) => io.observe(el));
  }

  /* ---------------- gallery ---------------- */
  const gallery = document.querySelector('nasqa-gallery');
  const stage = gallery?.querySelector('.gallery__stage');

  if (gallery && stage) {
    /* pointer-tracked zoom on devices that actually hover */
    if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
      stage.addEventListener('pointermove', (event) => {
        const r = stage.getBoundingClientRect();
        const x = ((event.clientX - r.left) / r.width) * 100;
        const y = ((event.clientY - r.top) / r.height) * 100;
        gallery.style.setProperty('--zoom-x', `${x}%`);
        gallery.style.setProperty('--zoom-y', `${y}%`);
      });
      stage.addEventListener('pointerenter', () => gallery.classList.add('is-zooming'));
      stage.addEventListener('pointerleave', () => gallery.classList.remove('is-zooming'));
    }

    /*
     * The gallery used to advance itself every 5.2s by synthesising a click on
     * the next button. That is removed, deliberately and permanently.
     *
     * Two reasons. On a shapewear PDP the shopper is comparing front against
     * back against the fabric macro; moving the image out from under her while
     * she is deciding is a conversion defect, not a showcase. And an
     * auto-advancing carousel with no pause control is a WCAG 2.2.2 failure —
     * hover-pause does not satisfy it on touch, where most of this traffic is.
     *
     * The visitor drives the gallery: thumbs, arrows, swipe, arrow keys.
     */
  }

  /* ---------------- add to cart feedback ---------------- */
  /* Fires on the real success event from theme.js, never on the click. */
  document.addEventListener('nasqa:add-success', (event) => {
    const btn = event.target.closest('[data-atc]');
    if (!btn) return;
    btn.classList.add('is-added');
    setTimeout(() => btn.classList.remove('is-added'), 900);
  });
})();
